import gql from "graphql-tag";

export const MY_TIMESHEET_REJECT_TIMESHEET = gql`
  mutation rejectMysheetTimesheet($_id: String!, $message: String) {
    rejectMysheetTimesheet(_id: $_id, message: $message)
  }
`;
